// Max note images shown before collapsing into a "+N" overflow tile
export const MAX_VISIBLE_IMAGES = 4

// Character count past which a note body is truncated behind "Read more"
export const NOTE_COLLAPSE_CHARS = 120
